import { education } from "../Utils/datas";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Education = () => {

    return (
        <>
            <div id="edubox" className="container">
                <div className="works-item-tags">Education</div>

                <VerticalTimeline>
                    {education.map((edu, index) => (
                        <VerticalTimelineElement
                            key={index}
                            className="vertical-timeline-element--education"
                            date={edu.year}
                            iconStyle={{ background: '#00BFFF', color: '#000000' }}
                        >
                            <h3 className="vertical-timeline-element-title">{edu.school}</h3>
                            <h4 className="vertical-timeline-element-subtitle">{edu.course}</h4>
                            <h5 className="vertical-timeline-element-subtitle">{edu.year}</h5>

                        </VerticalTimelineElement>
                    ))}
                </VerticalTimeline>

            </div>

        </>
    )
}
export default Education;